import Constant from '@/const';
import axios from 'axios';

const AuthenticationCheck = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/configuration/pcare/auth'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default AuthenticationCheck;
